var map = {
	"./attractions1.avif": 323,
	"./attractions2.avif": 324,
	"./attractions3.avif": 325,
	"./attractions4.avif": 326,
	"./attractions5.avif": 327,
	"./attractions6.avif": 328,
	"./attractions7.avif": 329,
	"./attractions8.avif": 330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 322;